import {useEffect} from "react";
import BaseModal from "@/components/BaseModal";
import InstallationPrompt from "@/components/Modals/InstallationPrompt";
import NotificationPrompt from "@/components/Modals/NotificationPrompt";
import PagoMovilListModal from "@/components/Modals/PagoMovilListModal";
import PagoMovilRegistrationModal from "@/components/Modals/PagoMovilRegistrationModal";
import ProfileOnboardingModal from "@/components/Modals/ProfileOnboardingModal";
import UpdatePrompt from "@/components/Modals/UpdatePrompt";
import {ConfEnv} from "@/config/config";
import useNeedsProfileOnboarding from "@/hooks/useNeedsProfileOnboarding";

/**
 * Session popups that depend on React Query must live inside QueryClientProvider.
 */
const AppSessionPopups = ({
  authStatus,
  showNotificationPrompt,
  setShowNotificationPrompt,
  pushSupported,
  userConsent,
  onRequestPermission,
  isSubscribing,
  pushError,
  showInstallPrompt,
  setShowInstallPrompt,
  installDeviceType,
  installPromptEvent,
}) => {
  const {needsOnboarding, isLoading: isOnboardingLoading} = useNeedsProfileOnboarding();
  const blockSessionPopups = needsOnboarding || isOnboardingLoading;

  useEffect(() => {
    if (blockSessionPopups) return;

    if (ConfEnv.ENV !== "development" && authStatus === "authenticated" && pushSupported && userConsent === "default") {
      const timer = setTimeout(() => {
        setShowNotificationPrompt(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [authStatus, blockSessionPopups, pushSupported, setShowNotificationPrompt, userConsent]);

  return (
    <>
      <BaseModal
        state={showNotificationPrompt && !blockSessionPopups}
        closeModal={() => setShowNotificationPrompt(false)}
        className="notification-prompt-modal"
        width="607px"
        closable={false}
      >
        <NotificationPrompt
          onClose={() => setShowNotificationPrompt(false)}
          onRequestPermission={() => {
            onRequestPermission();
            setShowNotificationPrompt(false);
          }}
          pushSupported={pushSupported}
          userConsent={userConsent}
          isSubscribing={isSubscribing}
          error={pushError}
        />
      </BaseModal>

      <BaseModal
        state={showInstallPrompt && !blockSessionPopups}
        closeModal={() => {
          localStorage.setItem("pwa_install_dismissed", String(Date.now()));
          setShowInstallPrompt(false);
        }}
      >
        <InstallationPrompt
          deviceType={installDeviceType}
          promptEvent={installPromptEvent}
          onClose={() => {
            localStorage.setItem("pwa_install_dismissed", String(Date.now()));
            setShowInstallPrompt(false);
          }}
        />
      </BaseModal>

      {authStatus === "authenticated" && (
        <>
          <ProfileOnboardingModal />
          <PagoMovilRegistrationModal />
          <PagoMovilListModal />
        </>
      )}

      <UpdatePrompt />
    </>
  );
};

export default AppSessionPopups;
